import { render } from "./Access.vue?vue&type=template&id=4e63e15a&scoped=true"
import script from "./Access.vue?vue&type=script&lang=js"
export * from "./Access.vue?vue&type=script&lang=js"

import "./Access.vue?vue&type=style&index=0&id=4e63e15a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4e63e15a"

export default script